import { Link } from "react-router-dom";
import { Construction, FileQuestion } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { EmptyState } from "@/components/fleet/EmptyState";
import { Button } from "@/components/ui/Button";
import { S } from "@/lib/strings";

/**
 * The routes that exist so links do not 404, and say plainly that the feature is
 * not here yet. A stub that pretends to be a real empty page ("沒有資料") is
 * worse than no route at all: it reads as a bug.
 */
export function Phase2Page({ title, body }: { title: string; body: string }) {
  return (
    <>
      <PageHeader title={title} hint={S.phase2Title} />
      <EmptyState icon={Construction} title={S.phase2Title} body={body} />
    </>
  );
}

export function NotFound() {
  return (
    <>
      <PageHeader title={S.notFoundTitle} />
      <EmptyState
        icon={FileQuestion}
        title={S.notFoundTitle}
        body={S.notFoundBody}
        action={
          <Link to="/overview">
            <Button variant="primary">{S.navOverview}</Button>
          </Link>
        }
      />
    </>
  );
}
